import { atom } from "recoil";

export const ProvincesState = atom({
    key: 'ProvincesState',
    default: null,
});